const ACTION_TYPE = "REGISTRATION";
export const REGISTRATION_SUCCESS = `${ACTION_TYPE}/REGISTRATION_SUCCESS`;
export const REGISTRATION_FAIL = `${ACTION_TYPE}/REGISTRATION_FAIL`;
export const LOGOUT_SUCCESS = `${ACTION_TYPE}/LOGOUT_SUCCESS`;

export const AFFILIATE_REGISTRATION_SUCCESS = `${ACTION_TYPE}/AFFILIATE_REGISTRATION_SUCCESS`;
export const AFFILIATE_REGISTRATION_FAIL = `${ACTION_TYPE}/AFFILIATE_REGISTRATION_FAIL`;
